import React, {useEffect, useState} from 'react';
import {Link, useOutletContext, useParams, useSearchParams} from 'react-router-dom';
import TitleMain from "../../../components/Title/TitleMain";
import {useModal} from "../../../contexts/ModalContext";
import {useUser} from "../../../contexts/UserContext";
import AxiosConfig from "../../../services/AxiosConfig";
import {useBreadcrumb} from "../../../contexts/BreadcrumbContext";
import {generateBreadcrumbSegmentsAdmin} from "../../../services/BreadcrumbService";
import SeanceCreation from "../../../components/Admin/Seances/SeanceCreation";
import styles from "../Admin.module.css";
import ParticipantCreation from "../../../components/Admin/Participants/ParticipantCreation";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEdit, faSquareCheck, faUser, faXmark} from "@fortawesome/free-solid-svg-icons";
import {getParticipationStatusIcon, parseParticipationStatus} from "../../../services/SeanceService";
import Routing from "../../../services/routing";
import DateService from "../../../services/DateService";

function AdminParticipationPage() {
    const {user} = useUser();
    const {showModal, hideModal} = useModal();
    const [myApiData, setMyApiData] = useState([]);
    const {entrepriseId, contratId, activiteId, seanceId, participationId} = useParams();
    const { updateDynamicBreadcrumb } = useBreadcrumb();
    const [entreprise, setEntreprise] = useState({});
    const [contrat, setContrat] = useState({});
    const [activite, setActivite] = useState({});
    const [seance, setSeance] = useState({});
    const [participation, setParticipation] = useState({});
    const [searchParams] = useSearchParams();
    const mode = searchParams.get('mode') || 'consultation';

    const handleSuccess = (children = "Note enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 1500});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 1500});
    };

    const putActifOpenModal = () => {
        const text = participation.actif ? "supprimer" : "activer";
        showModal('confirm', {
            message: `Voulez-vous vraiment ${text} cette participation ?`,
            onConfirm: async () => {
                try {
                    const response = await AxiosConfig.post(`/admin/entreprises/${entreprise.id}/contrats/${contrat.id}/activites/${activite.id}/seances/${seance.id}/participations/${participation.id}/actif`, {actif: !participation.actif});
                    if (response.data.success) {
                        handleSuccess("Modifié avec succès");
                        setTimeout(() => {
                            window.location.reload();
                        }, 500);
                    } else {
                        handleError();
                    }
                } catch (error) {
                    console.error('error', error);
                    handleError();
                }
            }
        });
    }

    useEffect(() => {
        (async () => {
            try {
                const response = await AxiosConfig.get(`/admin/entreprises/${entrepriseId}/contrats/${contratId}/activites/${activiteId}/seances/${seanceId}/participations/${participationId}`);

                const parseData = response.data.myParticipation;
                setMyApiData(parseData);
                setContrat(response.data.myContrat);
                setEntreprise(response.data.myEntreprise);
                setActivite(response.data.myActivite);
                setSeance(response.data.mySeance);
                setParticipation(response.data.myParticipation);
            } catch (error) {
                console.error('error', error);
            }
        })();

        const entrepriseName = "My Entretreprise";
        const segments = [
            { path: '/admin/entreprises', name: 'Entreprises' },
            { path: `/admin/entreprises/entrepriseId`, name: entrepriseName },
        ];

        updateDynamicBreadcrumb(segments);
    }, [user]);

    useEffect(() => {
        updateDynamicBreadcrumb(generateBreadcrumbSegmentsAdmin({ entreprise, contrat, activite, seance, participation }));
    }, [ entreprise, contrat, activite, seance, participation ]);


    return (
        <div className="content">
            <TitleMain text="Participation"/>

            {mode === "creation" ? <ParticipantCreation entreprise={entreprise} contrat={contrat} activite={activite} seance={seance} asu={participation}/> :
                <div style={{display: "flex", flexDirection: "column", gap: "10px"}} className={styles.viewBloc}>
                    <div className={styles.headerBtnsVue}>
                         <button onClick={putActifOpenModal}>{participation?.actif ? <><FontAwesomeIcon
                            icon={faXmark}/>Supprimer</> : <><FontAwesomeIcon
                            icon={faSquareCheck}/>Restaurer</>}</button>
                        <Link to={Routing.routes.adminCreation}><FontAwesomeIcon icon={faEdit}/>Modifier</Link>
                    </div>

                    <p className={styles.creerParLeBloc}>
                        Créé le {DateService.formatDate(participation?.created_at)} et mis à jour
                        le {DateService.formatDate(participation?.updated_at)} {participation.deleted_at ? "et supprimé le " +DateService.formatDate(participation?.deleted_at) : ""}
                    </p>

                    <p>
                        <FontAwesomeIcon icon={faUser}/>
                        {participation.participant?.prenom && participation.participant?.nom &&
                        <Link to={Routing.generate({
                            route: Routing.routes.adminUtilisateur,
                            params: { utilisateurId: participation?.participant?.id.toString()}
                        })}>
                            {participation.participant?.prenom} {participation.participant?.nom}
                        </Link>}
                    </p>

                    <div>
                        <p>Statut : {parseParticipationStatus(participation?.status)} {getParticipationStatusIcon(participation?.status)}</p>

                        <p>Présence {participation.valid_presence ?
                            <span style={{color: "var(--clr-success)"}}>validée</span> :
                            <span style={{color: "var(--clr-danger)"}}>non validée</span>}
                        </p>

                        <p>Note : {participation.rating ??
                            <span style={{color: "var(--clr-danger)"}}>Pas de note</span>}</p>

                        <p>Popup pour rappel de note {participation?.show_modal_rating ?
                            <span style={{color: "var(--clr-success)"}}>activée</span> :
                            <span style={{color: "var(--clr-danger)"}}>désactivée</span>}</p>
                    </div>

                </div>
            }

        </div>
    )
}

export default AdminParticipationPage;
